import React from 'react';
import './contacto.css';
import fotoMapa from "./componentes/mapa-cuenca-muebles.png"

const ContactSection = () => {
  // Datos de contacto
  const contacto = {
    direccion: "Cuenca, San Joaquin",
    horario: {
      semana: "Lunes a Viernes: 8:00 AM - 5:00 PM",
      sabado: "Sábados: 08:00 AM - 2:00 PM"
    },
    telefonos: [
      { numero: "+593 98 802 4805", tipo: "Móvil" },
      { numero: "099 415 4933", tipo: "Móvil" },
      { numero: "095 917 6656", tipo: "Móvil" },
      { numero: "096 869 4679", tipo: "Móvil" },
      { numero: "072 370 325", tipo: "Fijo" }
    ],
    whatsapp: "+593988024805",
    email: "pinomuebleria01@gmail.com"
  };

  // Función para abrir WhatsApp
  const openWhatsApp = () => {
    window.open(`https://wa.me/${contacto.whatsapp}?text=Hola%20El%20Pino%20Mueblería,%20me%20interesa%20obtener%20más%20información`, '_blank');
  };

  return (
    <section id="contact-section" className="contact-section">
      <div className="contact-container">
        <h2 className="section-title">Contáctanos</h2>
        
        <div className="contact-content">
          {/* Información de contacto */}
          <div className="contact-info-section">
            <div className="contact-info">
              <div className="contact-item">
                <div className="icon-container">
                  <i className="icon">📍</i>
                </div>
                <div className="contact-details">
                  <h3>Dirección</h3>
                  <p className="contact-text">{contacto.direccion}</p>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="icon-container">
                  <i className="icon">🕒</i>
                </div>
                <div className="contact-details">
                  <h3>Horario de Atención</h3>
                  <div className="schedule">
                    <p className="schedule-day">{contacto.horario.semana}</p>
                    <p className="schedule-day">{contacto.horario.sabado}</p>
                  </div>
                </div>
              </div>
              
              <div className="contact-item">
                <div className="icon-container">
                  <i className="icon">📞</i>
                </div>
                <div className="contact-details">
                  <h3>Teléfonos</h3>
                  <div className="phones-container">
                    {contacto.telefonos.map((telefono, index) => (
                      <div key={index} className="phone-item">
                        <span className="phone-number">{telefono.numero}</span>
                        <span className="phone-type">{telefono.tipo}</span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>

             
            </div>
            
            <button className="whatsapp-button" onClick={openWhatsApp}>
              <div className="whatsapp-content">
                <i className="whatsapp-icon">💬</i>
                <span className="whatsapp-text">Envíanos un WhatsApp</span>
              </div>
              <div className="whatsapp-hint">Respuesta inmediata</div>
            </button>
          </div>
          
          {/* Sección de Mapa con Foto */}
          <div className="map-section">
            <div className="map-header">
              <h3>Ubicación</h3>
              <p>Encuéntranos en Cuenca, Ecuador</p>
            </div>
            <div className="map-photo-container">
              <a 
                href="https://maps.app.goo.gl/D9tSZEpHTVYHeq138" 
                target="_blank" 
                rel="noopener noreferrer"
                className="map-photo-link"
              >
                <img 
                  src={fotoMapa} 
                  alt="Mapa de Cuenca - El Pino Mueblería"
                  className="map-photo"
                />
                <div className="map-overlay">
                  <div className="map-overlay-content">
                    <i className="map-pin">📍</i>
                    <span className="map-click-text">Haz clic para ver en Google Maps</span>
                    <span className="map-address">Cuenca, San Joaquin</span>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;